import { Component, output, model } from '@angular/core';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
    selector: 'app-qr-referral',
    templateUrl: './qr-referral.component.html',
    styleUrl: './qr-referral.component.scss',
    imports: [NzModalModule, NzSpaceModule, NzButtonModule]
})
export class QrReferralComponent {
	readonly showQRModal = model<boolean>();
	readonly showRegistration = output();

	handleOk(): void {
		this.handleCancel();

		setTimeout(() => {
			this.showRegistration.emit();
		}, 500);
	}

	handleCancel(): void {
		const url = new URL(window.location.href);
		url.searchParams.delete('csuid');
		window.history.replaceState({}, document.title, url.toString());

		this.showQRModal.set(false);
	}
}
